import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[i2gScrollIntoFocus]',
})
export class ScrollIntoFocusDirective implements OnInit {
  /**
   * scrollIntoView arguments
   */
  @Input() scrollIntoViewOptions: boolean | ScrollIntoViewOptions = {
    behavior: 'smooth',
  };

  /**
   * Delay in ms before starting scroll
   */
  @Input() scrollDelay = 0;

  private _el: any;

  constructor(private _elementRef: ElementRef) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;
  }

  @HostListener('click', [])
  onClickEvent() {
    if (this.scrollDelay) {
      setTimeout(() => {
        this._el.scrollIntoView(this.scrollIntoViewOptions);
      }, this.scrollDelay);
    } else {
      this._el.scrollIntoView(this.scrollIntoViewOptions);
    }
  }
}
